import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  "pk_test_51QWkiyP8zLTR48KriXdBblhrEMT1KblJeFOsDfH9fLlB8N4dsC4oaglr8xlBMezLLeysBYe7S3ZeOkegTVWIvfUk00UFwZZZwB"
);

const Checkout = ({ product }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/create-checkout-session`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(product),
      }
    );
    const session = await response.json();

    const stripe = await stripePromise;
    const { error } = await stripe.redirectToCheckout({
      sessionId: session.sessionId,
    });

    if (error) {
      console.error(error);
    }
    setLoading(false);
  };

  return (
    <button onClick={handleClick} disabled={loading} className="text-onWhite">
      {loading ? "Chargement..." : "Payer maintenant"}
    </button>
  );
};

export default Checkout;
